import img01 from '../../../data/images/album/1.png';
import img02 from '../../../data/images/album/2.png';
import img03 from '../../../data/images/album/3.png';
import img04 from '../../../data/images/album/4.png';
import img05 from '../../../data/images/album/5.png';
import img06 from '../../../data/images/album/6.png';
import img07 from '../../../data/images/album/7.png';
import img08 from '../../../data/images/album/8.png';
import img09 from '../../../data/images/album/9.png';
import img10 from '../../../data/images/album/10.png';
import img11 from '../../../data/images/album/11.png';
import img12 from '../../../data/images/album/12.png';
import img13 from '../../../data/images/album/13.png';
import img14 from '../../../data/images/album/14.png';
import img15 from '../../../data/images/album/15.png';



export default [
    { css: img01, height: 600 },
    { css: img02, height: 600 },
    { css: img03, height: 600 },
    { css: img04, height: 600 },
    { css: img05, height: 600 },
    { css: img06, height: 600 },
    { css: img07, height: 600 },
    { css: img08, height: 600 },
    { css: img09, height: 600 },
    { css: img10, height: 600 },
    { css: img11, height: 600 },
    { css: img12, height: 600 },
    { css: img13, height: 600 },
    { css: img14, height: 600 },
    { css: img15, height: 600 },
  ]